import { useEffect } from "react";
import stateRecojo from "assets/images/state-recojo.png";
import stateEntregado from "assets/images/state-entregado.png";
import stateTransitoTerrestre from "assets/images/state-transito.png";
import stateTransitoAereo from "assets/images/state-transito-aereo.png";
import stateTransitoMaritimo from "assets/images/state-transito-maritimo.png";

const publicUrl = process.env.REACT_APP_PUBLIC_URL;
const publicImagePath = process.env.REACT_APP_IMAGE_PATH;

const stateImages = [
	{
		stateId: 1,
		image: stateRecojo,
	},
	{
		stateId: 2,
		image: stateTransitoTerrestre,
	},
	{
		stateId: 3,
		image: stateEntregado,
	},
	{
		stateId: 4,
		image: stateRecojo,
	},
	{
		stateId: 5,
		image: stateRecojo,
	},
	{
		stateId: 6,
		image: stateTransitoMaritimo,
	},
	{
		stateId: 7,
		image: stateRecojo,
	},
	{
		stateId: 8,
		image: stateTransitoAereo,
	},
	{
		stateId: 9,
		image: stateEntregado,
	},
];

const State = ({ trackingState, trackingOrder }) => {
	console.log("trackingState", trackingState);

	return (
		<>
			{trackingState.map((state, index) => {
				const { image } = stateImages.find((image) => image.stateId === state.stateId);

				return (
					<div className="tracking-states__row mb-12 relative" key={`${state.stateName}${index}`}>
						<div className="bullet rounded-full w-6 h-6 absolute top-1/2 border-2 border-black bg-white bullet-active" style={{ left: `calc(50% - 0.65em)` }}></div>
						<div className="grid grid-cols-6 gap-4 items-center">
							<div className="col-span-2">
								<h3 className="font-bold text-2xl underline tracking-states__name">{state.stateName}</h3>
								<div className="mb-2">
									<p>
										<strong>FECHA Y HORA:</strong>
									</p>
									<p>{state.dateTime}</p>
								</div>
								{(state.stateId === 1 || state.stateId === 7) && (
									<div className="mb-2">
										{state.regionName && (
											<div className="lugar">
												<p>
													<strong>LUGAR:</strong>
												</p>
												<p>{`${state.streetName || ""}, ${state.districtName || ""}, ${state.provinceName || ""}, ${state.regionName || ""}, ${state.countryName || ""}.`}</p>
											</div>
										)}

										<div className="comentarios">
											<p className="mt-2">
												<strong>COMENTARIOS:</strong>
											</p>
										</div>
										<p>{`${state.comment || "-"}`}</p>
									</div>
								)}

								{(state.stateId === 3 || state.stateId === 9) && (
									<div className="mb-2">
										{trackingOrder.street && (
											<div>
												<p>
													<strong>LUGAR:</strong>
												</p>

												<p>{`${trackingOrder.street || ""}, ${trackingOrder.district || ""}, ${trackingOrder.province || ""}, ${trackingOrder.region || ""}, ${trackingOrder.country || ""}.`}</p>

												<p className="mt-2">
													<strong>COMENTARIOS:</strong>
												</p>
												<p>{`${state.comment || "-"}`}</p>
											</div>
										)}
									</div>
								)}
								<div className="grid grid-cols-2">
									{
									state.imageName 
										? Array.isArray(state.imageName) 
											? (
												state.imageName.map(photo => (
													<a href={`${publicImagePath}/${photo}`} target="_blank" rel="noreferrer" className="block ml-1 mb-1">
														<img src={`${publicImagePath}/${photo}`} alt="Foto Entregado" className="w-full"/>
													</a>
												))
											) 
											: 
											(
												<a href={`${publicImagePath}/${state.imageName}`} target="_blank" rel="noreferrer">
													<img src={`${publicImagePath}/${state.imageName}`} alt="Foto Entregado" />
												</a>
											)
										:
										''
									}
								</div>
							</div>
							<div className="col-span-2 justify-self-end col-start-5">
								<div className="state__image ml__circle-state ml__background--blue-gradient flex items-center justify-center">
									<img src={image} alt="recojo" />
								</div>
							</div>
						</div>
					</div>
				);
			})}
		</>
	);
};

export default State;
